webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(30);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(22);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Home = __webpack_require__(23);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Information = __webpack_require__(24);
	
	var _Information2 = _interopRequireDefault(_Information);
	
	var _Knowledge = __webpack_require__(25);
	
	var _Knowledge2 = _interopRequireDefault(_Knowledge);
	
	var _Message = __webpack_require__(26);
	
	var _Message2 = _interopRequireDefault(_Message);
	
	var _School = __webpack_require__(27);
	
	var _School2 = _interopRequireDefault(_School);
	
	var _Zhihu = __webpack_require__(28);
	
	var _Zhihu2 = _interopRequireDefault(_Zhihu);
	
	var _vueRouter = __webpack_require__(29);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var app = _vue2.default.extend(_App2.default);
	
	var router = new _vueRouter2.default();
	
	router.map({
		'/home': {
			name: 'home',
			component: _Home2.default
		},
		'/information': {
			name: 'information',
			component: _Information2.default
		},
		'/knowledge': {
			name: 'knowledge',
			component: _Knowledge2.default
		},
		'/message': {
			name: 'message',
			component: _Message2.default
		},
		'/school': {
			name: 'school',
			component: _School2.default
		},
		'/zhihu': {
			name: 'zhihu',
			component: _Zhihu2.default
		}
	});
	
	router.redirect({
		'/': '/home'
	});
	router.start(app, '#app');

/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		data: function data() {
			return {
				wechatImg: "http://ww4.sinaimg.cn/large/0060lm7Tgw1f8wp70tlecj305k05kdg0.jpg",
	
				isN: false
			};
		},
	
		methods: {
			gohistory: function gohistory() {
				window.history.back();
			},
			nigthMode: function nigthMode() {
				var isN = void 0;
				this.isN = !this.isN;
				if (this.isN === true) {
					console.log("夜间模式已开启");
				} else {
					console.log("夜间模式已关闭");
				}
			},
			reload: function reload() {
				window.location.reload();
			}
		}
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	         value: true
	});
	exports.default = {
	         data: function data() {
	                  return {
	                           slides: [{ img: 'http://ww2.sinaimg.cn/large/0060lm7Tgw1f8rm92vjxpj309s064jrm.jpg' }, { img: 'http://ww3.sinaimg.cn/large/0060lm7Tgw1f8rm92ueyqj30av064wep.jpg' }, { img: 'http://ww1.sinaimg.cn/large/0060lm7Tgw1f8rm92u5eij309s064q31.jpg' }],
	                           icons: [{ img: "../static/1.png" }, { img: "../static/2.png" }, { img: "../static/3.png" }, { img: "../static/4.png" }, { img: "../static/5.png" }, { img: "../static/6.png" }, { img: "../static/7.png" }, { img: "../static/8.png" }, { img: "../static/9.png" }, { img: "../static/10.png" }, { img: "../static/11.png" }, { img: "../static/12.png" }]
	
	                  };
	         },
	
	         ready: function ready() {
	                  console.log("home-dom准备完毕");
	                  $(".swiper-container").swiper();
	         }
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    jj: function jj() {
	      $.toast('项目维护中...', 2345, 'tips');
	    }
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    jj: function jj() {
	      $.toast('项目维护中...', 2345, 'tips');
	    }
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var duoshuoQuery = { short_name: "jgsdx" };
	(function () {
		var ds = document.createElement('script');
		ds.type = 'text/javascript';ds.async = true;
		ds.src = (document.location.protocol == 'https:' ? 'https:' : 'http:') + '//static.duoshuo.com/embed.js';
		ds.charset = 'UTF-8';
		(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(ds);
	})();
	exports.default = {
		methods: {
			reload: function reload() {
				window.location.reload();
			}
		}
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      items: [{
	        name: "新闻中心",
	        src: "../static/jd/xwzx.html"
	      }, {
	        name: "通知公告",
	        src: "../static/jd/tzgg.html"
	      }, {
	        name: "学术讲座",
	        src: "../static/jd/xsjz.html"
	      }, {
	        name: "学院动态",
	        src: "../static/jd/xydt.html"
	      }, {
	        name: "科研信息",
	        src: "../static/jd/kyxx.html"
	      }, {
	        name: "教务通知",
	        src: "../static/jd/jwtz.html"
	      }]
	    };
	  },
	
	  methods: {
	    goif: function goif(i) {
	      document.getElementById("ifId").src = i.src;
	      document.getElementById('listId').style = "display:none";
	      document.getElementById('ifId').style = "display:block";
	    }
	  }
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      items: [{
	        name: "日常心理学",
	        src: "../static/zh/Psychology.html"
	      }, {
	        name: "用户推荐日报",
	        src: "../static/zh/Recinnebded.html"
	      }, {
	        name: "电影日报",
	        src: "../static/zh/Movie.html"
	      }, {
	        name: "不许无聊",
	        src: "../static/zh/Noboring.html"
	      }, {
	        name: "设计日报",
	        src: "../static/zh/Design.html"
	      }, {
	        name: "大公司日报",
	        src: "../static/zh/Bigcompanies.html"
	      }, {
	        name: "财经日报",
	        src: "../static/zh/Game.html"
	      }, {
	        name: "互联网安全",
	        src: "../static/zh/Safe.html"
	      }, {
	        name: "开始游戏",
	        src: "../static/zh/Game.html"
	      }, {
	        name: "音乐日报",
	        src: "../static/zh/Music.html"
	      }, {
	        name: "动漫日报",
	        src: "../static/zh/Comic.html"
	      }, {
	        name: "体育日报",
	        src: "../static/zh/Sports.html"
	      }, {
	        name: "职人介绍所",
	        src: "../static/zh/Jobintroduction.html"
	      }, {
	        name: "24 小时热门",
	        src: "../static/zh/Hot_24.html"
	      }, {
	        name: "小事",
	        src: "../static/zh/Trivial.html"
	      }]
	    };
	  },
	
	  methods: {
	    goif: function goif(i) {
	      document.getElementById("ifId").src = i.src;
	      document.getElementById('listId').style = "display:none";
	      document.getElementById('ifId').style = "display:block";
	    }
	  }
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 9 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 10 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 11 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 12 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 13 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 14 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = " <div :class=\"{'theme-dark':isN}\"> <div class=\"page page-current\"> <header class=\"bar bar-nav\"> <a class=\"button button-link button-nav pull-left close-panel\" @click=gohistory() data-transition=slide-out> <span class=\"icon icon-left\"></span> </a> <a class=\"button button-link button-nav pull-right open-panel\" data-transition=slide-out> <span class=\"icon icon-menu\"></span> </a> <h1 class=\"title close-panel\">{{$route.name}}</h1> </header> <nav class=\"bar bar-tab close-panel\"> <a class=\"tab-item active\" v-link=\"{name:'home',activeClass:'active'}\"> <span class=\"icon icon-home\"></span> <span class=tab-label>首页</span> </a> <a class=tab-item v-link=\"{name:'information',activeClass:'active'}\"> <span class=\"icon icon-browser\"></span> <span class=tab-label>资讯</span> </a> <a class=tab-item v-link=\"{name:'knowledge',activeClass:'active'}\"> <span class=\"icon icon-star\"></span> <span class=tab-label>涨知识</span> </a> <a class=tab-item v-link=\"{name:'message',activeClass:'active'}\"> <span class=\"icon icon-message\"></span> <span class=tab-label>留言板</span> </a> </nav> <div class=\"content close-panel\"> <router-view keep-alive></router-view> </div> </div> <div class=\"panel panel-left panel-reveal theme-dark\" id=panel-left-demo> <div class=\"content-block side_bar\"> <p>关于</p> <hr> <p>By vue.js（1.0）and sui - webapp</p> <p>源码地址</p> <p><a href=https://github.com/seaman-7/light>https://github.com/seaman-7/light</a></p> <p>反馈意见，一起学习</p> <img :src=wechatImg class=sub_wechat alt=wechat> <div class=row> <span class=col-33>版本号 : </span> <span class=pull-right> 1.01 beat </span> </div> <div class=row> <span class=col-40>夜间模式 :</span> <label class=\"label-switch pull-right\"> <input type=checkbox> <div @click=nigthMode() class=checkbox></div> </label> </div> </div> </div> </div> ";

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = " <div class=content> <div class=swiper-container data-space-between=10 data-pagination=.swiper-pagination> <div class=swiper-wrapper> <div v-for=\"slide in slides\" class=swiper-slide> <img :src=slide.img style=\"width: 100%;height:200px\" alt=\"\"> </div> </div> <div class=swiper-pagination></div> </div> <div class=\"bar content_icon\"> <div class=content-block-title>首页应用</div> <div v-for=\"icon in icons\"> <img :src=icon.img class=\"col-20 item_icon\"> </div> </div> </div> ";

/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports = " <div class=content> <div class=\"infor b01\"> <a v-link=\"{name:'school'}\"><i>The School</i></a> </div> <div class=\"infor b02\"> <a @click=jj()><i>The World</i></a> </div> <div class=\"infor b03\"> <a href=http://gotit.asia/cet><i>CET - 4 / 6</i></a> </div> </div> ";

/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports = " <div class=content> <div class=\"infor b04\"> <a v-link=\"{name:'zhihu'}\"><i>Zhihu</i></a> </div> <div class=\"infor b05\"> <a @click=jj()><i>Douban</i></a> </div> <div class=\"infor b06\"> <a @click=jj()><i>Others</i></a> </div> </div> ";

/***/ },
/* 19 */
/***/ function(module, exports) {

	module.exports = " <div class=message> <h2>留言板</h2> <p>评论、吐槽都在这，欢迎盖楼</p> </div> <span @click=reload() class=\"icon icon-refresh\"></span> <div class=ds-thread data-thread-key=message data-title=vue_jd&message data-url=http://seaman-7.github.io/message></div> ";

/***/ },
/* 20 */
/***/ function(module, exports) {

	module.exports = " <div class=content> <div id=listId> <div class=content-block-title>校园资讯</div> <div class=\"list-block media-list inset\"> <ul> <li v-for=\"item in items\"> <a @click=goif(item) class=\"item-link item-content\"> <div class=item-inner> <div class=item-title>{{item.name}}</div> </div> </a> </li> </ul> </div> </div> <iframe id=ifId :src=\"\"></iframe> <div class=content-block> <p><a href=http://gotit.asia/cet class=button>四六级查询</a></p> </div> </div> ";

/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = " <div class=content> <div id=listId> <div class=content-block-title>知乎日报</div> <div class=\"list-block media-list inset\"> <ul> <li v-for=\"item in items\"> <a @click=goif(item) class=\"item-link item-content\"> <div class=item-inner> <div class=item-title>{{item.name}}</div> </div> </a> </li> </ul> </div> </div> <iframe id=ifId :src=\"\"></iframe> </div> ";

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(8)
	__vue_script__ = __webpack_require__(1)
	__vue_template__ = __webpack_require__(15)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(9)
	__vue_script__ = __webpack_require__(2)
	__vue_template__ = __webpack_require__(16)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(10)
	__vue_script__ = __webpack_require__(3)
	__vue_template__ = __webpack_require__(17)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(11)
	__vue_script__ = __webpack_require__(4)
	__vue_template__ = __webpack_require__(18)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(12)
	__vue_script__ = __webpack_require__(5)
	__vue_template__ = __webpack_require__(19)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(13)
	__vue_script__ = __webpack_require__(6)
	__vue_template__ = __webpack_require__(20)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(14)
	__vue_script__ = __webpack_require__(7)
	__vue_template__ = __webpack_require__(21)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.c810da43ef567fffc522.js
 **/